'use client';

import { ArticleCard } from '@/sanity/fetchArticles';
import HIHImage from './HIHImage';
import HIHLink from './Link';
import { URL_PATH_ARTICLE } from '@/shared/constants';
import {
  MATOMO_CONTENT_INTERACTIONS,
  MATOMO_CONTENT_KINDS,
  buildContentPiece,
} from '@/utils/matomo';
import { useContentImpression } from '@/hooks/useContentImpression';
import { ContentBlockProvider } from './ContentTracking';
import styles from './SingleArticleCardMobileHorizontal.module.scss';
import ActionFavorite from '../action/favorite/ActionFavorite';

interface SingleArticleCardMobileHorizontalProps {
  article: ArticleCard;
  variant?: 'primary' | 'secondary';
}

export default function SingleArticleCardMobileHorizontal({
  article,
}: SingleArticleCardMobileHorizontalProps) {
  const articlePath = `/${URL_PATH_ARTICLE}/${article.slug.current}`;

  // Trackt nur innerhalb eines ContentTrackingModule, sonst No-Op – siehe ContentTracking.
  const { ref, block, trackInteraction } = useContentImpression({
    contentPiece: buildContentPiece(MATOMO_CONTENT_KINDS.GUIDE, article.slug.current),
    contentTarget: articlePath,
  });

  return (
    <ContentBlockProvider block={block}>
      <div ref={ref} className={styles.singleArticleCardMobileHorizontal}>
        <HIHLink
          key={article._id}
          href={articlePath}
          onClick={() =>
            trackInteraction(MATOMO_CONTENT_INTERACTIONS.DETAILSEITE_GEOEFFNET)
          }
        >
          <div className={styles.card}>
            <div className={styles.imageWrapper}>
              <HIHImage
                image={article.coverImage}
                width={90}
                height={90}
                fill
                className={styles.image}
              />
            </div>
            <div className={styles.info}>
              <div className={styles.titleWrapper}>
                <div className={styles.title}>{article.title}</div>
              </div>
            </div>
          </div>
        </HIHLink>
        <ActionFavorite
          id={article._id}
          className={styles.favoriteButton}
          bookmarkType="Guide"
          disableBackgroundColor={true}
        />
      </div>
    </ContentBlockProvider>
  );
}
